<script lang="ts">
  let {
    label,
    checked = $bindable(false),
    disabled = false,
    hint = ''
  }: {
    label: string;
    checked?: boolean;
    disabled?: boolean;
    hint?: string;
  } = $props();

  const checkboxId = `checkbox-${Math.random().toString(36).substr(2, 9)}`;
</script>

<div class="form-checkbox">
  <div class="checkbox-wrapper">
    <input
      id={checkboxId}
      type="checkbox"
      {disabled}
      bind:checked
    />
    <label for={checkboxId}>
      {label}
    </label>
  </div>
  {#if hint}
    <span class="hint">{hint}</span>
  {/if}
</div>

<style lang="scss">
  .form-checkbox {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);

    .checkbox-wrapper {
      display: flex;
      align-items: center;
      gap: var(--spacing-sm);

      input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        accent-color: var(--color-primary);

        &:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }

      label {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-medium);
        color: var(--color-text-secondary);
        cursor: pointer;

        &:has(+ input:disabled) {
          cursor: not-allowed;
          opacity: 0.5;
        }
      }
    }

    .hint {
      font-size: var(--font-size-xs);
      color: var(--color-text-tertiary);
      margin-left: 26px; // Align with label after checkbox
    }
  }
</style>
